import React, { Component } from 'react';
import { connect } from 'react-redux';

import DatePicker from 'material-ui-pickers/DatePicker';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';

// pick utils
import moment from 'moment';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import orange from '@material-ui/core/colors/orange';
import { localStoreFN } from '../../store/localStorage';

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#f99e60'
      }
    },
    MuiPickersDay: {
      selected: {
        backgroundColor: '#f99e60'
      },
      current: {
        color: orange['900']
      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#f99e60'
      }
    }
  }
});

/**
 * override method to format the date displayed in the calendar header
 */
class ExtendsMomentUtils extends MomentUtils {
  getDatePickerHeaderText(date) {
    const formatDate = localStoreFN().getItem('formatDate');
    return date.format(formatDate);
  }
}

class DateComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: props.first ? new Date() : null,
      style: {
        fontWeight: 'normal',
        borderRadius: '4px',
        height: 'auto',
        width: '100%'
      }
    };
    
    // get date format setting and save it to localstorage
    localStoreFN().setItem('formatDate', props.language.account.date.format || 'ddd, MMM D');

    // get language configuration to set the calendar
    this.languageDatePicker = localStoreFN().getItem('lang');
    moment.locale(this.languageDatePicker);
  }
  
  componentWillMount() {
    const dateformat = moment(new Date()).format('YYYY-MM-DD');
    const rest = moment(dateformat);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedDate) {
      this.props.defaultDate(prevState.selectedDate);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.clearRow == true) {
      this.setState(state => {
        selectedDate: state.selectedDate = null;
      });
    }
  }

  handleDateChange = date => {
    const obj = JSON.parse(this.props.setting.value);
    let newDate = !date ? new Date() : date;
    this.setState({ selectedDate: newDate });
    this.props.handleSubmit({
      date: moment(newDate).format(this.props.language.account.date.format),
      id: this.props.id
    });
  };

  render() {
    return (
      <MuiPickersUtilsProvider utils={ExtendsMomentUtils} locale={this.languageDatePicker} moment={moment}>
        <MuiThemeProvider theme={materialTheme}>
          <div className="picker">
            <DatePicker
              id={this.props.id}
              data-style="date_picker"
              value={this.props.asignDate ? this.props.asignDate : this.state.selectedDate}
              onChange={this.handleDateChange}
              style={this.state.style}
              clearable={false}
              autoOk={true}
              leftArrowIcon="<"
              rightArrowIcon=">"
              format={this.props.language.account.date.format}
              cancelLabel={this.props.language.account.accountExtendedProperty.modal.buttonCancel}
              okLabel={this.props.language.account.accountExtendedProperty.modal.buttonOK}
            />
          </div>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateComponent);



// WEBPACK FOOTER //
// ./source/client/components/allocator/dateFilterInit.jsx